import React, { useEffect, useState } from "react";
import {
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Box,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import BackButton from "../../../components/BackButton";
import StyledTableContainer from "../../../components/StyledTableContainer";
import { useLocation, useNavigate } from "react-router-dom";
import TableTxtField from "./TableTxtField";
import { useAuthContext } from "../../../context/AuthContext";
import { customAlert, notify } from "../../../components/notify";
import route from "../../../utils/Routes";
import { CreateCatalogServ } from "../../../services/com-service";
import { isNotEmpty } from "../../../utils/format";

const columns = [
    { id: "serial", label: "S.No", align: "left", minWidth: 10 },
    { id: "prodName", label: "Product", align: "left", minWidth: 200 },
    { id: "amtcProdIdStrg", label: "AMTC Product ID", align: "left", minWidth: 200 },
    { id: "comProdIdStrg", label: "Material Code", align: "left", minWidth: 200 },
    { id: "priceAgreeId", label: "Price Agreement ID", align: "left", minWidth: 200 },
    { id: "agreedQty", label: "Agreed Quantity", align: "left", minWidth: 130 },
    { id: "AgreedPrice", label: "Agreed Price (OMR)", align: "left", minWidth: 200 },
    { id: "comProdTax", label: "Tax(%)", align: "left", minWidth: 130 },
    { id: "agreedFrom", label: "Agreed From", align: "left", minWidth: 150 },
    { id: "agreedTo", label: "Agreed To", align: "left", minWidth: 150 },
];
const AddProdToCompCatalog2 = () => {
    const theme = useTheme();
    const location = useLocation();
    const { setLoadingScreen, setNavComValue } = useAuthContext();
    const { comId, selProds } = location.state || {};
    const navigate = useNavigate();
    const [rows, setRows] = useState([
        {
            serial: 1,
            prodName: "",
            amtcProdIdStrg: "",
            comProdIdStrg: "",
            priceAgreeId: "",
            agreedQty: "",
            AgreedPrice: "",
            comProdTax: "",
            agreedFrom: "",
            agreedTo: "",
        },
    ]);

    const [errors, setErrors] = useState({});


    useEffect(() => {
        if (!comId)
            navigate("/", { replace: true })
        if (!selProds)
            navigate("/", { replace: true })
        else
            setValuesToRow(selProds);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comId, selProds]);

    useEffect(() => {
        setNavComValue({ comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);

    function setValuesToRow(data) {
        const arr = data.map((i, index) => ({
            serial: index + 1,
            prodName: i?.prodName,
            amtcProdIdStrg: i?.amtcProdIdStrg,
            comProdIdStrg: "",
            priceAgreeId: "",
            agreedQty: "",
            AgreedPrice: "",
            comProdTax: "",
            agreedFrom: null,
            agreedTo: null,
        }))
        setRows(arr);
    }

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const validate = () => {
        const newErrors = {};
        rows.forEach((row, index) => {
            Object.keys(row).forEach((key) => {
                // if (!row[key] && key !== "serial") {
                //     newErrors[`${index}-${key}`] = "Required";
                // }
                if (!row[key] && key === "comProdIdStrg") {
                    newErrors[`${index}-${key}`] = "Required";
                }

            });
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    async function handleSubmit(e) {
        e.preventDefault();
        if (!validate()) return;
        setLoadingScreen(true);
        try {
            const payload = {
                comId,
                productArr: rows.map((row) => ({
                    amtcProdIdStrg: row.amtcProdIdStrg,
                    comProdIdStrg: row.comProdIdStrg,
                    priceAgreeId: row.priceAgreeId,
                    agreedQty: Number(row.agreedQty),
                    AgreedPrice: Number(row.AgreedPrice),
                    comProdTax: Number(row.comProdTax),
                    agreedFrom: isNotEmpty(row.agreedFrom) ? row.agreedFrom : null,
                    agreedTo: isNotEmpty(row.agreedTo) ? row.agreedTo : null,
                })),
            };
            console.dir(payload);
            const { message } = await CreateCatalogServ(payload);
            notify("success", message);
            navigate(`${route.aCompany}/?comId=${comId}&tab=2`)
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    async function handleCancel() {
        navigate(`${route.aCompany}/?comId=${comId}&tab=2`)
    }





    return (
        <Box height={"90%"} width={"100%"} px={2}>
            <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
                <BackButton width={"20%"} />
                <Stack direction={"row"} alignItems={'center'} justifyContent={'center'} width={"60%"}>
                    <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Add Product To Company Catalog</Typography>
                </Stack>
                <Box width={"20%"} />
            </Stack>

            {selProds && <StyledTableContainer height={"81%"} isStickyHeader={true}>
                <TableHead>
                    <TableRow >
                        {columns.map((column) => (
                            <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {(rows || []).map((i, index) => {
                        return (
                            <React.Fragment key={i?.serial}>
                                <TableRow hover tabIndex={-1}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50, cursor: 'pointer' }} >
                                    {columns.map((column) => {
                                        const value = i[column.id];
                                        switch (column.id) {
                                            case "agreedQty":
                                            case "AgreedPrice":
                                            case "comProdTax":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    <TableTxtField type={"number"} value={value} errMsg={errors[`${index}-${column.id}`]}
                                                        onChange={(e) => handleInputChange(index, column.id, e.target.value)} />
                                                </TableCell>
                                            case "agreedFrom":
                                            case "agreedTo":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    <TableTxtField type={"Date"} value={value ?? ""} errMsg={errors[`${index}-${column.id}`]}
                                                        onChange={(e) => handleInputChange(index, column.id, e.target.value)} />
                                                </TableCell>
                                            case "comProdIdStrg":
                                            case "priceAgreeId":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    <TableTxtField value={value} errMsg={errors[`${index}-${column.id}`]}
                                                        onChange={(e) => handleInputChange(index, column.id, e.target.value)} />
                                                </TableCell>
                                            case "prodName":
                                            case "amtcProdIdStrg":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    <TableTxtField value={value} errMsg={errors[`${index}-${column.id}`]}
                                                        readOnly={true} bgColor={"rgba(162, 214, 249, 0.18)"} />
                                                </TableCell>
                                            default:
                                                return (
                                                    <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {(value === null || value === "" || value === "null") ? "NA" : value}
                                                    </TableCell>
                                                );
                                        }
                                    })}
                                </TableRow>
                            </React.Fragment>
                        );
                    })}
                </TableBody>
            </StyledTableContainer>}
            <Box sx={{ position: "absolute", bottom: 20, right: 20 }}>
                <Button variant="outlined" onClick={handleCancel} sx={{
                    fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
                    color: theme.palette.custom.btn, mr: 2,
                }}>CANCEL</Button>
                <Button variant="contained" type="submit" onClick={handleSubmit}
                    sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>ADD</Button>
            </Box>
        </Box>
    );
};

export default AddProdToCompCatalog2;